import { createStyles } from "@mantine/core";
import { IHealthStatusProps } from "./types";
import { HEALTH_INDICATOR_SIZE } from "../HealthIndicator/constants";

export const useStyles = createStyles(
  (theme, { health, mb, mt }: IHealthStatusProps) => ({
    wrapper: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      margin: `${
        typeof mt === "number" ? `${mt}px` : mt || `${theme.spacing.xs}px`
      } 0 ${
        typeof mb === "number" ? `${mb}px` : mb || `${theme.spacing.xs}px`
      } 0`,
      paddingLeft: health ? `${HEALTH_INDICATOR_SIZE}px` : 0,
      position: "relative",
    },

    icon: {
      left: 0,
      marginTop: "1px",
      position: "absolute",
      top: "50%",
      transform: "translate(0, -50%)",
    },

    text: {
      wordBreak: "keep-all",
    },
  }),
);
